import pLogo from 'assets/images/p-logo.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import FormMessage from '../../FormMessage';
import { setCurrentBet as dispatchSetCurrentBet } from '../actions';
import LoadMore from '../LoadMore';
import { getCurrentBetId, getOpenBetsIds, hasNextSlip } from '../selectors';
import BetListItemConnect from './BetListItem';

export const BetList = ({
  setCurrentBet,
  betsIds,
  currentBetId,
  showLoadMore
}) => {
  const handleClick = () => {
    setCurrentBet(currentBetId);
  };

  return (
    <div className="open-bets-list">
      {currentBetId && (
        <button
          type="button"
          className="open-bets-list__close-button"
          onClick={handleClick}
        >
          Close list
          <i className="open-bets-list__close-icon material-icon material-icon--arrow-drop-up" />
        </button>
      )}
      <div className="container--fixed">
        <header className="open-bets-list__header">
          <FormMessage className="open-bets-list__message" slotId="default" />
          <h2 className="open-bets-list__heading">Summary of open bets</h2>
          <p className="open-bets-list__instructions">
            Select any open bet for latest scores, in play stats and cash in offers.
          </p>
          <h4 className="open-bets-list__subheading">
            <img src={pLogo} className="open-bets-list__p-logo" /> = Online funded bet
          </h4>
        </header>
        <ul className="open-bets-list__bets">
          {
            betsIds.map(betId => (<BetListItemConnect betId={betId} key={betId} />))
          }
        </ul>
        {showLoadMore && <LoadMore>Load more</LoadMore>}
      </div>
    </div>
  );
};

BetList.propTypes = {
  setCurrentBet: PropTypes.func.isRequired,
  betsIds: PropTypes.object.isRequired,
  currentBetId: PropTypes.string,
  showLoadMore: PropTypes.bool
};

const mapStateToProps = state => ({
  betsIds: getOpenBetsIds(state),
  currentBetId: getCurrentBetId(state),
  showLoadMore: hasNextSlip(state)
});

const mapDispatchToProps = {
  setCurrentBet: dispatchSetCurrentBet
};

export default connect(mapStateToProps, mapDispatchToProps)(BetList);
